import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2e95fe7d&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=2e95fe7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e95fe7d",
  null
  
)

export default component.exports